import { Injectable, inject } from '@angular/core';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { BehaviorSubject, filter, take } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import Avo, { AvoEnv } from './Avo';
import { SegmentDestination } from './segment.destination';
import { AnalyticsConfig } from '../analytics.config';
import { environment } from 'src/environments/environment';
import { AvoSystemProperties } from './avo.types';

@Injectable({
  providedIn: 'root',
})
export class AvoService {
  private readonly deviceDetector = inject(DeviceDetectorService);
  private readonly ready$ = new BehaviorSubject<boolean>(false);
  private isAvoInitialized = false;

  async initialize(
    config: AnalyticsConfig,
    analyticsBrowser: AnalyticsBrowser,
  ): Promise<void> {
    if (this.isAvoInitialized) {
      return;
    }

    const systemProperties: AvoSystemProperties = {
      appVersion: config.appVersion,
      ...this.getDeviceInfo(),
      systemRocketAccountId: '',
      systemRvid: '',
      systemRocketMortgageClientId: '',
      systemClientId: '',
      systemGcid: '',
      systemCommonId: '',
      systemRockHumanId: '',
      systemSessionReplayId: '',
      systemEventId: '',
      systemCooperCustomerId: undefined,
    };

    const isProduction = environment.envName === 'production';
    Avo.initAvo(
      {
        env: isProduction ? AvoEnv.Prod : AvoEnv.Dev,
        webDebugger: !isProduction,
      },
      systemProperties,
      {},
      new SegmentDestination(analyticsBrowser),
    );

    this.isAvoInitialized = true;
    this.ready$.next(true);
  }

  whenReady() {
    return this.ready$.pipe(
      filter((ready) => ready),
      take(1),
    );
  }

  private getDeviceInfo() {
    const deviceInfo = this.deviceDetector.getDeviceInfo();
    return {
      deviceType: this.deviceDetector.deviceType || 'unknown',
      osVersion: `${deviceInfo.os || 'unknown'} ${deviceInfo.os_version || 'unknown'}`,
      browserVersion: `${deviceInfo.browser || 'unknown'} ${deviceInfo.browser_version || 'unknown'}`,
      userAgent: deviceInfo.userAgent || 'unknown',
    };
  }
}
